import {
  DataDownloadContent,
  DataDownloadHeader,
  DataDownloadProvider,
} from '@factorialco/f0-react'
import type { DataDownloadCanvasContent } from '@factorialco/f0-react'

import { defineCanvasEntity } from 'modules/ai/copilotActions/canvas/defineCanvasEntity'

/**
 * Canvas renderer for `{ type: "dataDownload" }` content. The provider
 * tracks export state so the header (export buttons) and content (table)
 * share it.
 */
export const dataDownloadCanvasEntity = defineCanvasEntity<DataDownloadCanvasContent>({
  type: 'dataDownload',
  renderContent: ({ content, refreshKey }) => (
    <DataDownloadContent content={content} refreshKey={refreshKey} />
  ),
  renderHeader: ({ content, onClose }) => (
    <DataDownloadHeader content={content} onClose={onClose} />
  ),
  wrapper: ({ content, children }) => (
    <DataDownloadProvider content={content}>{children}</DataDownloadProvider>
  ),
})
